// extracted by mini-css-extract-plugin
module.exports = {"academyScope":"academy_academyScope__6yWXM"};